import axios from 'axios'
import { useEffect, useState } from 'react'

import { StavRizeniFetchResult } from '../../common/insolvencyMonitoringTypes'
import { useAppSelector } from '../../redux/hooks'

export const useFetchInsolvencyEnums = () => {
  const token = useAppSelector(state => state.myProfile.token)

  const [result, setResult] = useState<StavRizeniFetchResult>({
    fetching: true,
    error: false,
    data: null,
  })

  useEffect(() => {
    const fetchData = async () => {
      try {
        setResult(prev => ({ ...prev, fetching: true }))
        const response = await axios.get(
          `https://data.regesta.cz/DrmApi/api/v1.0/Ciselniky/Insolvence/Veci/StavRizeni?access_token=${token}`
        )

        setResult({
          fetching: false,
          error: false,
          data: response.data,
        })
      } catch (error) {
        setResult({
          fetching: false,
          error: true,
          data: null,
        })
      }
    }

    fetchData()
  }, [token])

  return result
}
